import { render, staticRenderFns } from "./ParticipantMetricsChartBoxPlot.vue?vue&type=template&id=f2fe1e2e&scoped=true"
import script from "./ParticipantMetricsChartBoxPlot.vue?vue&type=script&lang=js"
export * from "./ParticipantMetricsChartBoxPlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fe1e2e",
  null
  
)

export default component.exports